import { all } from 'redux-saga/effects';
import settingsSagas from './settings';
import postersSagas from './posters';
import tagsSagas from './tags';
import socialSagas from "./Social";

export default function* rootSaga() {
	yield all([settingsSagas(), postersSagas(), tagsSagas(), socialSagas()]);
}
